var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('gatewayDetailWin',_vm._b({ref:"detailDialog",attrs:{"detailObj":_vm.detailObj,"deviceType":_vm.deviceType,"deviceProperty":_vm.deviceProperty,"netObj":_vm.netObj}},'gatewayDetailWin',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }